import { ApplicationRoutes } from '../../../app-routes-names'

export const CallIntelligenceRoutes = {
  dashboard: 'dashboard',
  leadsList: 'leads',
  leadsCost: 'leads-cost',
  drilldown: 'drilldown'
}

const { callIntelligence } = ApplicationRoutes

export const CallIntelligencePaths = {
  dashboard: `/${callIntelligence}/${CallIntelligenceRoutes.dashboard}`,
  leadsList: `/${callIntelligence}/${CallIntelligenceRoutes.leadsList}`,
  leadsCost: `/${callIntelligence}/${CallIntelligenceRoutes.leadsCost}`,
  drilldown: `/${callIntelligence}/${CallIntelligenceRoutes.drilldown}`
}
